import { Injectable } from '@angular/core';
import { Container } from 'pixi.js';
import { debounceTime, fromEvent } from 'rxjs';
import { GameStateService } from '../game-state/game-state.service';
import { SignialsService } from '../signals/signials.service';
import { GamePoint } from '../../interfaces/common-interfaces';
import { isMobile, startMooving } from '../../classes/common/helpers';
import { BG_LAYER_HEIGHT, BG_LAYER_WIDTH } from '../../constants/game-constants';
import gsap from 'gsap';


@Injectable({
  providedIn: 'root'
})
export class GameContainersService {
	field: Container;
	mainField: Container;
	camera: Container;

  constructor(
		private state: GameStateService,
		private signal: SignialsService,
	) {
		this.state.containers = this;
	}

	createField() {
		this.field = new Container();

		this.field.interactive = true;
		this.field.sortableChildren = true
		this.field.eventMode = 'static';

		this.resized();
		this.subscribeToResize();

		this.field.on('pointerup', (e) => {
			if (e.button !== 0) return;
			if (this.state.gamePause || this.state.inTrap) return;
			const {x, y} = this.field.toLocal({x: e.globalX, y: e.globalY});
			this.signal.fieldClicked.next([x, y]);
		});

		return this.field;
	}

	createCamera() {
		this.camera = new Container();
		this.camera.interactive = true;
		this.camera.sortableChildren = true;
		this.camera.eventMode = 'static';

		return this.camera;
	}

	getTopCenterPosition(): GamePoint {
		const fieldScale = this.field.scale.x;
		return [-BG_LAYER_WIDTH * fieldScale / 2 + window.innerWidth / 2, BG_LAYER_HEIGHT * fieldScale * 2];
	}

	sceneToUser(transition = 1, point?: GamePoint, fixedLocation = true, fieldScale?: number, multipl = 1) {
		if (fieldScale) { 
			this.field.scale.set(this.field.scale.x * fieldScale);
		} else {
			fieldScale = this.field.scale.x * multipl;
		}
		const nextX = point ? point[0] : (this.state.player?.spine.x || 820);
		const nextY = point ? point[1] : (this.state.player?.spine.y || 1050);
		let x = -(nextX * this.field.scale.x) + window.innerWidth / 2 ;
	
		const count = window.innerHeight / (BG_LAYER_HEIGHT * fieldScale) - 1;
		let y = this.state.player ? -(nextY * this.field.scale.x) + window.innerHeight/ 2 + this.state.player.spine.height / 2 : BG_LAYER_HEIGHT * fieldScale * count;

		y = y < BG_LAYER_HEIGHT * fieldScale * count ? BG_LAYER_HEIGHT * fieldScale * count : y;
		y = y > BG_LAYER_HEIGHT * fieldScale * 2 ? BG_LAYER_HEIGHT * fieldScale * 2 : y;

		const realWidth = BG_LAYER_WIDTH * this.field.scale.x;
		x = x > 0 ? 0 : x;
		x = x < 0 && (window.innerWidth + -x) > realWidth ? window.innerWidth - realWidth : x;

		return startMooving(this.field, [x, y], transition);
	}

	private subscribeToResize() {
		fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
			this.resized();
		});
	}

	setFieldScale() {
		setTimeout(() => {
			let scale = window.innerHeight / BG_LAYER_HEIGHT;
			if (isMobile() && window.innerHeight > window.innerWidth) {
				// // 📱 Мобильная портретная ориентация — "cover"-режим
				// const scaleX = window.innerWidth / BG_LAYER_WIDTH;
				// const scaleY = window.innerHeight / (BG_LAYER_HEIGHT * 3);
				// scale = Math.max(scaleX, scaleY); // гарантирует, что фон покроет весь экран
				scale = 0.6;
			}
			let fieldWidth = BG_LAYER_WIDTH * scale;
			if (fieldWidth < window.innerWidth) {
				scale = window.innerWidth / BG_LAYER_WIDTH;
			}
			this.field?.scale.set(scale) && this.sceneToUser(0);
		}, 0);
	}

	setScale(scale = 1, cb?: () => void, duration = 0.3, delay = 0) {
		gsap.to(
			this.camera, {
				pixi: {
					scale
				},
				duration,
				delay,
				ease: 'none'
			},
		).then(() => cb?.());
		// this.resized();
		// this.mainField?.pivot.set(window.innerWidth / 2, window.innerHeight / 2);
		// this.mainField?.position.set(window.innerWidth / 2, window.innerHeight / 2);
	}
	public resized() {
		this.camera?.pivot.set(window.innerWidth / 2, window.innerHeight / 2);
		this.camera?.position.set(window.innerWidth / 2, window.innerHeight / 2);
		// this.field?.position.set(0, window.innerHeight);
		this.setFieldScale();
	}
}
